<template>
<div id="content">
    <h1>{{completionMessage}}</h1>
</div>
</template>

<script>
export default {
    name: "StartSuccess",
    data() {
        return {
            completionMessage: ""
        };
    },
    created() {
         if (this.$route.params.otherProps != undefined) {
            this.completionMessage = this.$route.params.otherProps.completionMessage;
         }
    }
};
</script>
<style scoped>
#content {
    vertical-align: middle;
    text-align: center;
    margin-top: 100px;
}
</style>
